module.exports = __webpack_public_path__ + "img/2_C.b1bd1074.png";